<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-23 15:16:58
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-08 14:16:33
 * @FilePath: \合联\oms\src\view\forecastManagement\temporaryStorageOverseas\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/forecastManagement/temporaryStorageOverseas";
import btns from "../../../components/tables/handle-btns";
export default {
  name: "temporaryStorageOverseas",
  components: {
    cTable
  },
  mounted() {},
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        edit: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("编辑"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { status: 24 },
            { delivery_number: 12, delivery_volume: 12 },
            { c_time: 12, complete_time: 12 }
          ],
          fields: [
            {
              name: this.$tz("状态"),
              key: "status",
              component: "Select",
              placeholder: () => this.$tz("状态"),
              options: [],
              optionsFn: "towType",
              optionsKey: "",
              default: ""
            },
            {
              name: this.$tz("已送,数量"),
              key: "delivery_number",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            },
            {
              name: this.$tz("已送,体积"),
              key: "delivery_volume",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            },
            {
              name: () => this.$tz("到仓,时间"),
              key: "c_time",
              placeholder: () => this.$tz("到仓,时间"),
              component: "DatePicker",
              disabledDate: true,
              format: "YYYY-MM-DD HH:mm:ss",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              }
            },
            {
              name: () => this.$tz("派送,完成,时间"),
              key: "complete_time",
              placeholder: () => this.$tz("派送,完成,时间"),
              component: "DatePicker",
              disabledDate: true,
              format: "YYYY-MM-DD HH:mm:ss",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              }
            }
          ]
        },
        log: {
          config: {
            title: this.$tz("记录"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("服务项目"),
                key: "service",
                minWidth: 130
              },
              {
                name: () => this.$tz("货件编号"),
                key: "appointment_no",
                minWidth: 130
              },
              {
                name: () => this.$tz("送仓,数量"),
                key: "number",
                minWidth: 130
              },
              {
                name: () => this.$tz("送仓,体积"),
                key: "volume",
                minWidth: 130
              },
              {
                name: () => this.$tz("送仓,时间"),
                key: "delivery_time",
                minWidth: 130
              },
              {
                name: () => this.$tz("送仓,仓库"),
                key: "warehouse",
                minWidth: 130
              },
              {
                name: () => this.$tz("送仓,状态"),
                key: "delivery_status",
                minWidth: 130
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "warehouse_id",
            placeholder() {
              return this.$tz("仓库");
            },
            component: "Select",
            options: [],
            optionsFn: "predictionWarehouse",
            optionsKey: ""
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "service_id",
            placeholder() {
              return this.$tz("客服");
            },
            component: "Select",
            options: [],
            optionsFn: "service",
            optionsKey: "",
            apiData: [2]
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("状态");
            },
            component: "Select",
            options: [],
            optionsFn: "towType",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client",
          minWidth: 130
        },
        {
          name: () => this.$tz("公司名称"),
          key: "company",
          minWidth: 130
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("总,数量"),
          key: "number",
          minWidth: 130
        },
        {
          name: () => this.$tz("已送,数量"),
          key: "delivery_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("剩余,数量"),
          key: "residue_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("总,方数"),
          key: "volume",
          minWidth: 130
        },
        {
          name: () => this.$tz("已送,方数"),
          key: "delivery_volume",
          minWidth: 130
        },
        {
          name: () => this.$tz("剩余,方数"),
          key: "residue_volume",
          minWidth: 130
        },
        {
          name: () => this.$tz("订单,状态"),
          key: "status",
          minWidth: 130
        },
        {
          name: () => this.$tz("客服"),
          key: "service_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("起运国"),
          key: "from_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("目的国"),
          key: "to_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("仓库名称"),
          key: "warehouse",
          minWidth: 130
        },
        {
          name: () => this.$tz("运输方式"),
          key: "transport",
          minWidth: 130
        },
        {
          name: () => this.$tz("入仓,时间"),
          key: "c_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("暂存时长"),
          key: "time",
          minWidth: 130
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("操作,记录"),
              type: "log",
              fnName: "log",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("编辑"),
              type: "edit",
              fnName: "edit",
              bind: {
                type: "primary"
              },
              id: 1938
            }
          ],
          methods: {
            edit({ row }) {
              this.getModal("edit").open(row, function() {
                this.setTitle(this.$tz("编辑"));
              });
            },
            log({ row }) {
              this.handleRequestMethods(
                "log",
                { id: row.id },
                false,
                true
              ).then(res => {
                this.getModal("log").open(row, function() {
                  this.list = res.payload;
                  this.setTitle(this.$tz("操作,记录") + `${row.airway_number}`);
                });
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
